/**
 * @fileoverview Application entry point
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { LanguageProvider } from './contexts/LanguageContext.jsx';
import { NavigationGuardProvider } from './contexts/NavigationGuardContext.jsx';
import { DocumentDraftProvider } from './contexts/DocumentDraftContext.jsx';
import './styles/index.css';
ReactDOM.createRoot(document.getElementById('root')).render(<React.StrictMode>
  <AuthProvider>
    <LanguageProvider>
      <NavigationGuardProvider>
        <DocumentDraftProvider>
          <App />
        </DocumentDraftProvider>
      </NavigationGuardProvider>
    </LanguageProvider>
  </AuthProvider>
</React.StrictMode>);
